import { InterestAccountRequest, InterestAccount } from 'vopay';

import axios from 'axios';

import vopayApi from '@/services/api.config';
import { useState } from 'react';

const { api } = vopayApi;

export default function useFetchInterestAccounts() {
  const [fetchingInterestAccounts, setFetchingInterestAccounts] = useState(false);
  const [interestAccounts, setInterestAccounts] = useState<InterestAccount[]>([]);

  const source = axios.CancelToken.source();

  async function fetchInterestAccounts(requestParams: InterestAccountRequest) {
    try {
      setFetchingInterestAccounts(true);
      const res = await api.fetchInterestAccount(requestParams, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      // _TODO: CurrentBalance hardcoded until b/e has time to return it
      setInterestAccounts(
        res.InterestAccounts.map((account) => {
          return {
            ...account,
            CurrentBalance: '500.00',
          };
        }),
      );

      return res;
    } catch (err) {
      console.error(err);

      throw err;
    } finally {
      setFetchingInterestAccounts(false);
    }
  }

  return {
    interestAccounts,
    fetchInterestAccounts,
    fetchingInterestAccounts,
  };
}
